import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=4e3c7026&scoped=true&"
import script from "./personCenter.vue?vue&type=script&lang=js&"
export * from "./personCenter.vue?vue&type=script&lang=js&"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=4e3c7026&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c7026",
  null
  
)

export default component.exports